import { useEffect } from 'react';

const AnalyticsScripts = () => {
  useEffect(() => {
    const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
    const GTM_ID = process.env.REACT_APP_GTM_ID;

    // Google Analytics
    if (GA_ID) {
      // Load gtag.js
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(gaScript);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', GA_ID);
      window.gtag = gtag;
    }

    // Google Tag Manager
    if (GTM_ID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', GTM_ID);
    }
  }, []);

  return null;
};

export default AnalyticsScripts;
